import firebase from "@/libs/firebase.ts";
import { collection, getDocs, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { makeAutoObservable, runInAction } from "mobx";

export class StreamsStore {
  streams: any[] = [];
  loading = true;
  error: any = null;
  private unsubscribeFn?: () => void;
  private isAdminUser = false;

  constructor() {
    makeAutoObservable(this);
    this.subscribe();
  }

  setIsAdminUser(isAdminUser: boolean) {
    if (this.isAdminUser !== isAdminUser) {
      this.isAdminUser = isAdminUser;
      this.subscribe();
    }
  }

  subscribe() {
    this.loading = true;
    const db = firebase.firestore;
    const q = query(
      collection(db, "streams"),
      where("status", "==", "live"),
      orderBy("popularity", "desc")
    );
    this.unsubscribeFn?.();
    this.unsubscribeFn = onSnapshot(
      q,
      (snapshot) => {
        let streams = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        if (!(this.isAdminUser)) {
          streams = streams.filter((stream) => !(stream as any).isAdmin === true);
        }
        runInAction(() => {
          this.streams = streams;
          this.loading = false;
          this.error = null;
        });
      },
      (error) => {
        console.error("🔥 [StreamsStore] Firestore error:", error);
        runInAction(() => {
          this.error = error;
          this.loading = false;
        });
      }
    );
  }

  unsubscribe() {
    console.log("🔥 [StreamsStore] Unsubscribing from streams collection");
    this.unsubscribeFn?.();
    this.unsubscribeFn = undefined;
  }

}

export async function getLiveStreamsOneTime(isAdmin: boolean = false) : Promise<any[]> {
  const db = firebase.firestore;
  const q = query(
    collection(db, "streams"),
    where("status", "==", "live"),
    orderBy("popularity", "desc")
  );
  const snapshot = await getDocs(q);
  let streams = snapshot.docs
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .slice()

  if (!isAdmin) {
    streams = streams.filter((stream) => !(stream as any).isAdmin === true);
  }
  return streams;
}

export const streamsStore = new StreamsStore(); 
